import { Model } from "@interfaces/model.interface";
import { PurchasableItem } from "@interfaces/purchasableItem.interface";

export interface ProductionToolBomItem extends Model {
	notes: string;
	productionToolId: number;
	purchasableItem?: PurchasableItem;
	purchasableItemId: number;
	quantity: number;
}

export class ProductionToolBomItem implements ProductionToolBomItem {
	notes = "";
	quantity = 1;

	constructor(data?: Partial<ProductionToolBomItem>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
